import React from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { Icon } from '../Icon';
import { Button } from './Button';

export interface BackButtonProps {
	onClick: () => void;
}

export const BackButton = ({ onClick }: BackButtonProps) => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<Button
			color="primary"
			type="link"
			onClick={onClick}
			size="s"
			aria-label={t('navigation.back')}
			className="button-plain"
			iconStart={
				<Icon
					name="chevron-left"
					type="components"
				/>
			}>
			{t('navigation.back', { namespace: LocalizeNameSpaceTypes.Global })}
		</Button>
	);
};
